import React, { useState, useEffect } from "react";
import { Scheduler } from "@aldabil/react-scheduler";
import { ref, getDatabase, onValue } from "firebase/database";
import Loader from "../components/UI/loader";

function Calender() {
  const database = getDatabase();
  const customerRef = ref(database, "customers");
  const [loader, setLoader] = useState(false);
  const email = localStorage.getItem("email");
  const [events, setEvents] = useState([]);

  useEffect(() => {
    setLoader(true);
    const unsubscribe = onValue(customerRef, (snapshot) => {
      setLoader(false);
      const data = snapshot.val();
      if (data) {
        const filteredProjects = Object.values(data).filter(
          (project) => project.email === email
        );

        const dateCounts = filteredProjects.reduce((acc, project) => {
          const date = new Date(project.timeStamp).toDateString();
          if (!acc[date]) {
            acc[date] = {
              totalCount: 0,
              checkInCount: 0,
              projects: [],
            };
          }
          acc[date].totalCount += 1;
          if (project.status === "seated" || project.status === "done") {
            acc[date].checkInCount += 1;
          }
          acc[date].projects.push(project);
          return acc;
        }, {});

        const transformedEvents = Object.keys(dateCounts).map((date, index) => {
          const { totalCount, checkInCount, projects } = dateCounts[date];
          const start = new Date(date);
          const end = new Date(start.getTime() + 24 * 60 * 60 * 1000 - 1);
          return {
            event_id: index + 1,
            title: `Total: ${totalCount}, Served: ${checkInCount}`,
            start,
            end,
            projects,
          };
        });

        setEvents(transformedEvents);
      }
    });
    return () => unsubscribe();
  }, [email]);

  return (
    <div className="max-w-md mx-auto">
      <div className="px-5 pt-6 pb-2">
        <h1 className="text-2xl font-bold text-gray-900">Calendar</h1>
        <p className="text-sm text-gray-500 mt-1">
          View your waitlist history by date
        </p>
      </div>
      {loader ? (
        <Loader loading={loader} />
      ) : (
        <div className="mx-4 bg-white rounded-2xl shadow-card border border-gray-100 overflow-x-auto">
          <Scheduler
            view="month"
            events={events}
            editable={false}
            deletable={false}
            draggable={false}
            onEventDrop={null}
            onEventClick={null}
            eventRenderer={({ event }) => (
              <div>
                <strong>{event.title}</strong>
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
}

export default Calender;
